"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Styled = _interopRequireWildcard(require("./styles/ListItem.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ListItem = function ListItem(_ref) {
  var className = _ref.className,
      role = _ref.role,
      children = _ref.children,
      onClick = _ref.onClick,
      url = _ref.url,
      to = _ref.to,
      id = _ref.id,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      srText = _ref.srText,
      htmlAttributes = _ref.htmlAttributes,
      interactionRef = _ref.interactionRef,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$listType = _ref.listType,
      listType = _ref$listType === void 0 ? 'unordered' : _ref$listType,
      _ref$listStyle = _ref.listStyle,
      listStyle = _ref$listStyle === void 0 ? 'none' : _ref$listStyle;
  return /*#__PURE__*/_react["default"].createElement(Styled.ListItem, {
    id: id,
    className: className,
    role: role,
    "aria-disabled": disabled && !!onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    listType: listType,
    listStyle: listStyle
  }, onClick || url || to ? /*#__PURE__*/_react["default"].createElement(Styled.InteractionListItem, _extends({
    onInteraction: onClick,
    href: url,
    to: to,
    label: srText,
    domRef: interactionRef,
    disabled: disabled
  }, htmlAttributes), children) : children);
};

ListItem.displayName = "ListItem";
var _default = ListItem;
exports["default"] = _default;
//# sourceMappingURL=ListItem.js.map